import isEmpty from 'lodash.isempty';

const minFieldToShowResetButton = 2;

export namespace ResetButtonStateUtil {

  export function isHidden(key: string, queryParams: { [key: string]: any }): boolean {
    const { filter } = queryParams;

    if (!filter) {
      return true;
    }

    const { options } = filter;

    if (!options) {
      return true;
    }

    const optionValue = options[key];

    if (!optionValue || isEmpty(optionValue)) {
      return true;
    }

    const isArray = Array.isArray(optionValue);

    return !isArray || optionValue.length < minFieldToShowResetButton;
  }

  export function isHiddenForCategoriesFilter(queryParams: { [key: string]: any }): boolean {
    const { filter } = queryParams;

    if (!filter) {
      return true;
    }

    const { categories } = filter;

    if (!categories || isEmpty(categories)) {
      return true;
    }

    return !Array.isArray(categories) || categories.length < minFieldToShowResetButton;
  }
}
